export enum BorrowerIncomeLabel {
  W2 = 'W2',
  self_employed = 'Self-Employed/1099',
  va_disability = 'VA Disability',
  military_pension = 'Military Pension',
  employer_pension = 'Employer Pension',
  social_security = 'Social Security',
  rental_income = 'Rental Income',
  homemaker_unemployed = 'Homemaker/Unemployed',
  other = 'Other',
  other_description = '',
}
